import { COLLECTIONS, PATHS } from '__constants__'
import {
  deleteDocument,
  updateParentHasManyRelationship
} from 'services/api/firebase'
import { generatePath, useNavigate } from 'react-router-dom'
import { useEvent, useTranslations } from 'hooks'

import { message } from 'antd'
import { useMemo } from 'react'
import { useUser } from 'modules/session-module/contexts'

/* Path's */
const createPath =
  PATHS.AUTHENTICATED.TICKET_CREATE || PATHS.AUTHENTICATED.TICKET_WIZARD
const editPath = PATHS.AUTHENTICATED.TICKET_EDIT

const useTicketBaseActions = ({ ticketId, actions } = {}) => {
  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting navigate instance */
  const navigate = useNavigate()

  const { user } = useUser()

  /* Function to handle back click */
  const handleBack = useEvent(() => navigate(-1))

  /* Handling opening of the create page */
  const handleCreate = useEvent(() => {
    navigate(createPath)
  })

  /* Handling opening of the edit page or change view to edit mode */
  const handleEdit = useEvent(() => {
    const pathParams = { ticketId }
    const path = generatePath(editPath, pathParams)
    navigate(path)
  })

  const handleDelete = useEvent(async () => {
    try {
      await deleteDocument(COLLECTIONS.TICKETS, ticketId)

      await updateParentHasManyRelationship(
        user?._id,
        COLLECTIONS.USERS,
        'ticketIds',
        ticketId,
        true
      )
      message.success(t('Ticket successfully deleted'))
    } catch (error) {
      message.error(error.message)
    }
  })

  return useMemo(
    () => ({
      onBack: handleBack,
      onCreate: handleCreate,
      onEdit: handleEdit,
      onDelete: handleDelete,
      ...(actions || {}),
      createPath,
      editPath
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      actions?.onBack,
      actions?.onCreate,
      actions?.onDelete,
      actions?.onEdit,
      actions?.onOpen,
      handleBack,
      handleCreate,
      handleDelete,
      handleEdit
    ]
  )
}

export default useTicketBaseActions
